<script>
// import axios from "axios";

import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Vue from "vue";
import axios from "axios";
// import { FulfillingBouncingCircleSpinner } from "epic-spinners";
// register the plugin on vue
import Toasted from "vue-toasted";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";
Vue.use(Toasted);
import vSelect from 'vue-select'

// Lets Register a Global Error Notification Toast.
import Datepicker from 'vuejs-datepicker';
import moment from "moment";

import {es} from 'vuejs-datepicker/dist/locale';
import 'vue2-datepicker/index.css';
import 'vue-select/dist/vue-select.css';
Vue.component('v-select', vSelect)
/**
 * Categoria component
 */
export default {
  page: {
    title: "Categoría",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    datepicker: Datepicker,
  },
  data() {
    return {
        es :es,
      disabledDates: {
          to: '',
      },
        fecha_inicio: '',
        fecha_fin: '',
        gananciasNeta: 0,
      totalVentas: 0,
      totalGastos: 0,
      inversion: 0,
      GananciaProducto: 0,
      GananciaServicio: 0,
      repit: true,
      apiUrl: process.env.VUE_APP_URL,
      userT: this.$store.state.authfack.user,
      tiendasData:[],
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      
      title: "Reporte Ganancias",
      form: {
      nombre: "",
      apellido: '',
      opciones : ['MASCULINO', 'FEMENINO'],
      telefono : '',
      cui : '',
      sexo : '',
      direccion: "",
      email: "",
      fecha : '',
      tiendaid:"",
      state: true,
      id: 0,
    },
    };
  },
  validations: {
    
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
    this.getTiendas();
  },
  watch: {},
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    getTiendas(){
      let me = this;
      me.tiendasData = [];
      
      axios
        .get(process.env.VUE_APP_URL + "tiendas/busqueda",{
            headers: { "x-token": this.userT.token}
          })
        .then(function (response) {
          // console.log(response);
          me.tiendasData = response.data.data;
        })
        .catch(function (error) {
          console.log(error);
          this.showModalL = false;
        })
        .finally(() =>{
          
          this.showModalL = false;
         
        });
  },
    money(value) {
      return (
          "Q " +
          parseFloat(value)
              .toFixed(2)
              .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    async generateReport(){
        try {
                const urlas = process.env.VUE_APP_URL + 'reports/product_by_service?fecha_inicio=' +
                 this.customFormatter(this.fecha_inicio)+'&fecha_fin='+this.customFormatter(this.fecha_fin)+'&tiendaid='+this.form.tiendaid.id;
                console.log(this.form.tiendaid.id)
                const response = await axios({
                url: urlas, 
              
                headers: { "x-token": this.userT.token },
              
                method: 'GET',
                responseType: 'blob', // Importante para recibir el PDF como un Blob binario
                });

                // Crear un enlace temporal para forzar la descarga
                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'reporte_ganancias.pdf'); // Nombre del archivo de descarga
                document.body.appendChild(link);
                link.click(); // Forzar el clic para descargar

                // Eliminar el enlace temporal
                document.body.removeChild(link);
            } catch (error) {
                console.error('Error al descargar el PDF', error);
            }
    },
    updateDisableDates(){
      let me = this;
      if(new Date(me.customFormatter(me.fecha_inicio)).getTime() > new Date(me.customFormatter(me.fecha_fin))){
          me.$refs.myDatepicker.clearDate();
          me.fecha_fin = '';
      }
      me.disabledDates.to = new Date(me.fecha_inicio);
    },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    async changeTypeDates(fecha_inicio, fecha_fin) {
      // await this.separarfechas();
      this.fecha_inicio = fecha_inicio;
      this.fecha_fin = fecha_fin;
    },

    //Desactivar registro
    getGananciaTotales() {
      console.log(this.form.tiendaid)
      axios
        .get(process.env.VUE_APP_URL + 'reports/general_ganancia?fecha_inicio=' + this.customFormatter(this.fecha_inicio)+
        '&fecha_fin='+this.customFormatter(this.fecha_fin)
        +'&tiendaid='+this.form.tiendaid.id, 
        
        {
                headers: { "x-token": this.userT.token },
              })
        .then((response) => {
          console.log(response);
            this.totalVentas = response.data.totalVendido;
            this.inversion = response.data.TotalInvertido;
            this.GananciaProducto = response.data.totalGananciaProductos;
            this.GananciaServicio = response.data.totalGananciaServicios;
            this.gananciasNeta = response.data.GananciaTotal;
            this.totalGastos = response.data.totalGastos;
            // console.log(this.totalGastos);
        })
        .catch((error) => {
          this.errorMessage = error.message;
          Vue.toasted.error("Error para consultar", this.options);
        });
    },

  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    /**
     * Total no. of records
     */
  },
};
</script>


<template>
    <Layout>
        <PageHeader :title="title"  />
      <div class="row">
        <div class="col-12">
          <div class="card-container">
            <!-- Tarjeta de Ganancias -->
            <div class="card card-total-gastos">
              <div class="card-body">
                <h5 class="card-title">Total Gastos</h5>
                <p class="card-value"> {{ money(totalGastos) }}</p>
              </div>
            </div>
            <div class="card card-total-ventas">
              <div class="card-body">
                <h5 class="card-title">Total Ventas</h5>
                <p class="card-value"> {{ money(totalVentas) }}</p>
              </div>
            </div>
  
            <!-- Tarjeta de Total Ventas -->
            <div class="card card-inversion">
              <div class="card-body">
                <h5 class="card-title">Total Invertido</h5>
                <p class="card-value"> {{ money(inversion) }}</p>
              </div>
            </div>
  
            <!-- Tarjeta de Inversión -->
            <div class="card card-ganancias">
              <div class="card-body">
                <h5 class="card-title">Ganancia Producto</h5>
                <p class="card-value"> {{ money(GananciaProducto)}}</p>
              </div>
            </div>
  
            <!-- Tarjeta de Número de Ventas -->
            <div class="card card-ganancias">
              <div class="card-body">
                <h5 class="card-title">Ganancia Servicio</h5>
                <p class="card-value">{{ money(GananciaServicio) }}</p>
              </div>
            </div>
            <div class="card card-ganancias">
              <div class="card-body">
                <h5 class="card-title">Total Ganancia</h5>
                <p class="card-value">{{money( gananciasNeta - totalGastos) }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <!-- Nueva tarjeta para los DatePickers y botón -->
      <div class="row mt-4">
        <div class="col-12">
          <div class="card card-report card-expand">
            <div class="card-body text-center">
  <h5 class="card-title">Generar Reporte</h5>

  <!-- Agrupar filtros en una sola fila -->
  <div class="row justify-content-center">
    <!-- Fecha de Inicio -->
    <div class="col-sm-6 col-md-3">
      <label for="startDate">Fecha de Inicio</label>
      <datepicker
        :bootstrap-styling="true"
        @input="updateDisableDates()"
        placeholder="Fecha inicio"
        :language="es"
        :format="customFormatter"
        v-model="fecha_inicio"
      ></datepicker>
    </div>

    <!-- Fecha de Fin -->
    <div class="col-sm-6 col-md-3">
      <label for="endDate">Fecha de Fin</label>
      <datepicker
        :bootstrap-styling="true"
        @input="changeTypeDates(fecha_inicio, fecha_fin), getGananciaTotales()"
        ref="myDatepicker"
        placeholder="Fecha fin"
        :disabledDates="disabledDates"
        :language="es"
        :format="customFormatter"
        v-model="fecha_fin"
      ></datepicker>
    </div>

    <!-- Tienda -->
    <div class="col-sm-6 col-md-3">
      <label for="tiendaSelect">Tienda</label>
      <v-select
       @input="getGananciaTotales"
        id="tiendaSelect"
        v-model.trim="form.tiendaid"
        :options="tiendasData"
        label="nombre_tienda"
      ></v-select>
    </div>
  </div>

  <!-- Botón -->
  <div class="row justify-content-center mt-4">
    <div class="col-sm-12 col-md-6">
      <button class="btn btn-primary btn-block" @click="generateReport" >
        Generar Reporte
      </button>
    </div>
  </div>
</div>
          </div>
        </div>
      </div>
    </Layout>
  </template>


<style scoped>
.card-container {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding: 0 10px;
  flex-wrap: wrap; /* Permitir ue las tarjetas se ajusten en pantallas pequeñas */
}

.card {
  width: 100%;
  max-width: 250px;
  background-color: #f8f9fa;
  border: none;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  margin-bottom: 15px; /* Añadir un margen inferior entre las tarjetas */
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
}

.card-body {
  padding: 20px;
  text-align: center;
}

.card-title {
  font-size: 1.2rem;
  margin-bottom: 10px;
  color: #333;
}

.card-value {
  font-size: 1.5rem;
  font-weight: bold;
  color: #000;
}

/* Estilos por tarjeta */
.card-ganancias {
  background-color: #d4edda; /* Verde suave */
  color: #155724;
}

.card-total-ventas {
  background-color: #cce5ff; /* Azul suave */
  color: #004085;
}

.card-inversion {
  background-color: #fff3cd; /* Amarillo suave */
  color: #856404;
}

.card-total-gastos {
  background-color: #f8d7da; /* Rojo suave */
  color: #721c24;
}

/* Estilos para la tarjeta de los DatePickers */
.card-report {
  background-color: #f8f9fa;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 20px;
}

/* Expande la tarjeta para ocupar todo el ancho */
.card-expand {
  max-width: 100%;
  width: 100%;
  margin-top: 20px;
}

.btn-primary {
  background-color: #007bff;
  border-color: #007bff;
  width: 100%;
}

.btn-primary:hover {
  background-color: #0069d9;
}


.card-expand {
  position: relative;
  overflow: visible;
  min-height: 400px;
}
.date-picker-container {
  position: absolute;
  top: 100%; /* Muestra el DatePicker justo debajo del input */
  left: 0;
  z-index: 1000;
  overflow: visible; /* Permite que el calendario se vea fuera del contenedor */
}
.date-picker {
  z-index: 10000 !important;
}

/* Media queries para pantallas pequeñas */
@media (max-width: 768px) {
  .card-container {
    flex-direction: column;
    align-items: center;
  }

  .card {
    max-width: 100%;
  }

  .card-body {
    padding: 15px;
  }

  .btn-primary {
    font-size: 1rem;
  }

  .card-title {
    font-size: 1rem;
  }

  .card-value {
    font-size: 1.2rem;
  }

  .row {
    margin-left: 0px;
    margin-right: 0px;
  }
}

</style>